export default {"src":"/_next/static/media/wc-icon.128b638a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};